import React, { useState } from "react";
import { StyleSheet, Pressable, Text, View } from "react-native";

type TabProps = {
  tabs: string[];
  initialTab?: string;
  activeTab?: string;
  onTabSwitch?: (tab: string) => void;
  tabWidth?: number;
  tabPadding?: number;
  fontSize?: number;
  containerStyle?: any;
};

const Tab: React.FC<TabProps> = ({
  tabs,
  initialTab,
  activeTab,
  onTabSwitch,
  tabWidth,
  tabPadding,
  fontSize,
  containerStyle,
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState(
    activeTab || initialTab || tabs[0],
  );
  const currentActiveTab = activeTab || internalActiveTab;

  const handleTabSwitch = (tab: string) => {
    setInternalActiveTab(tab);
    if (onTabSwitch) onTabSwitch(tab);
  };

  return (
    <View style={[styles.tabContainer, containerStyle]}>
      {tabs.map((tab) => (
        <Pressable
          key={tab}
          onPress={() => handleTabSwitch(tab)}
          style={[
            styles.tabButton,
            tabWidth !== undefined && { width: tabWidth },
            tabPadding !== undefined && { padding: tabPadding },
            currentActiveTab === tab && styles.tabButtonActive,
          ]}
        >
          <Text
            style={[styles.tabText, fontSize !== undefined && { fontSize }]}
          >
            {tab}
          </Text>
        </Pressable>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  tabContainer: {
    marginHorizontal: "auto",
    flexDirection: "row",
    borderRadius: 10,
    backgroundColor: "#F8F8F8",
    alignSelf: "flex-start",
  },
  tabButton: {
    padding: 5,
    width: 100,
    alignItems: "center",
    justifyContent: "center",
  },
  tabText: {
    fontSize: 16,
    color: "black",
    fontFamily: "Urbanist600",
  },
  tabButtonActive: {
    backgroundColor: "rgba(0, 183, 244, 0.10)",
    borderRadius: 10,
  },
  contentContainer: {
    marginTop: 10,
  },
});

export default Tab;
